
import { connect } from 'react-redux';
import AppLayout from '../../components/layouts/AppLayout'




const mapStateToProps = state => {
    return {
      common: state.common,
      isLogin : state.app.isLogin
    }
};


export default connect(mapStateToProps)(AppLayout);